import { FC, useMemo, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { Paper, Typography } from "@mui/material";
import {
  GridFilterModel,
  GridLogicOperator,
  GridPaginationModel,
  GridSortModel,
} from "@mui/x-data-grid-pro";
import { isNumber } from "lodash";
import __ from "src/utils/Translations";
import { useFetchEmployeeAbsenceRequests } from "src/Pages/Company/Absences/api/useAbsenceRequest";
import parseTableFilters from "src/utils/Company/Absences/parseTableFilters";
import AbsenceRequestsTable from "src/Pages/Company/Absences/AbsenceRequests/AbsenceRequestsTable";

const AbsenceRecordsEmployeeRequests: FC = () => {
  const { employeeId } = useParams<{ employeeId: string }>();
  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
    page: 0,
    pageSize: 10,
  });

  const [sortModel, setSortModel] = useState<GridSortModel>([]);

  const [filterModel, setFilterModel] = useState<GridFilterModel>({
    items: [],
    logicOperator: GridLogicOperator.And,
  });

  const requestParams = useMemo(
    () => ({
      page: paginationModel.page + 1,
      size: paginationModel.pageSize,
      sort: sortModel?.map(({ field, sort }) => `${field},${sort}`),
      employeeId,
      filters: parseTableFilters(filterModel),
    }),
    [
      employeeId,
      filterModel,
      paginationModel.page,
      paginationModel.pageSize,
      sortModel,
    ]
  );

  const { data, isFetching } = useFetchEmployeeAbsenceRequests(requestParams);

  const rowCountRef = useRef(data?.totalElements || 0);
  const rowCount = useMemo(() => {
    if (isNumber(data?.totalElements)) {
      rowCountRef.current = data.totalElements;
    }
    return rowCountRef.current;
  }, [data?.totalElements]);

  return (
    <Paper data-testid="absence-records-employee-requests">
      <Typography variant="h6" component="h2" p="1.5rem">
        {__("Lista wniosków")}
      </Typography>
      <AbsenceRequestsTable
        loading={isFetching}
        rows={data?.content || []}
        rowCount={rowCount}
        storageKey="absence-request-employee-table-state"
        sortModel={sortModel}
        setSortModel={setSortModel}
        paginationModel={paginationModel}
        setPaginationModel={setPaginationModel}
        filterModel={filterModel}
        setFilterModel={setFilterModel}
        showEmployeeData={false}
      />
    </Paper>
  );
};

export default AbsenceRecordsEmployeeRequests;
